import { Component } from '@opten/compiler/metadata/component';
import { ChildrenRef } from '@opten/compiler/metadata/di';
import { OnInit } from '@opten/compiler/metadata/lifecycle';

// import Select from './select';
import {Select} from '@opten/select';
import { mapFields, getFields, setFieldsFromJson } from '../utilities/form';
import { setStorage, deleteStorage, getStorage } from '../utilities/storage';
import { SelectComponent } from '../../../Opten.HypothekarbankLenzburg.Core.Static/components/select/select';

export const MortgageFundingProposalFormKey = 'MortgageCalculatorForm';
export const ignoreReadMortgage: Array<string> = [
    '__RequestVerificationToken',
    'ufprt',
    'ProposalId',
    'SpanIds',
];

@Component({ className: 'js-mortgage-funding-proposal-form' })
export default class MortgageCalculatorForm implements OnInit {
    private _ignoreRead = ignoreReadMortgage;
    
    private _ignoreWrite: Array<string> = [
        'Calculator.Type',
        'Calculator.ConstructionCosts',
        'Calculator.Capital',
        'Calculator.FundingCapital',
        'Calculator.MarketValue',
        'Calculator.IsPrivatelyOwnedHome',
        // 'Calculator.IsForVacations',
        'Calculator.AnnualNetIncome',
        'Calculator.BirthdayYear',
        'Calculator.Date'
    ];

    get active(): boolean {
        return (
            this.element.getAttribute('data-cookie') &&
            this.element.getAttribute('data-cookie').toLowerCase() === 'true'
        );
    }

    @ChildrenRef(SelectComponent)
    	_selects: Array<SelectComponent>;
    constructor(private element: HTMLFormElement) {
        this._ignoreRead.forEach(ignore => this._ignoreWrite.push(ignore));
    }

    onInit() {
        if (!this.active) {
            deleteStorage(MortgageFundingProposalFormKey);

            return;
        }

        const cookie = getStorage(MortgageFundingProposalFormKey);

        // read cookie and try to set the form values
        if (cookie) {
            try {
                setFieldsFromJson(
                    this.element,
					this._selects.map(o => o.select),
                    JSON.parse(cookie),
                    this._ignoreWrite
                );
            } catch {
                /* todo: do we need to handle here something? */
            }
        }
        else{
            // store initial cookie (Calculator)
            this._save();
        }

        

        getFields(this.element, this._ignoreRead).forEach(field => {
            if (field.tagName === 'select') {
                field.addEventListener('change', () => this._save());
            } else {
                field.addEventListener('blur', () => this._save());
            }
        });
    }

    private _save() {
        const json = {};
        mapFields(this.element, this._ignoreRead).forEach(
            (value, key) => (json[key] = value)
        );

        setStorage(MortgageFundingProposalFormKey, JSON.stringify(json));
    }
}
